import Cookies from 'universal-cookie'

const cookies = new Cookies()

export default function getSegmentUserIdFromCookie(): string | undefined {
  return cookies.get('ajs_user_id')
}
